import { mapActions, mapGetters } from "vuex";

export const commandeMixin = {
  computed: {
    ...mapGetters({
      commandes: "commande/list/items",
      commandesNoCa: "commande/listNoCa/items",
      commandesIsLoading: "commande/list/isLoading",
    }),
  },
  methods: {
    ...mapActions({
      getCommandes: "commande/list/getItems",
      getCommandesNoCa: "commande/listNoCa/getItems",
    }),
  },
};
